// extracted by mini-css-extract-plugin
export default {"commentHeader":"GFzqL","search":"GloWe","commentTime":"huY74","withMoreButton":"Jl5C5","moreButton":"LaR7j","isBestAnswer":"bWyan"};